angular.module('impactx.smartform').controller('SFTDialogCtrl', SFTDialogCtrl);
SFTDialogCtrl.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdDialog',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'SmartFormTemplateCache',
    'ConfirmationService',
    'ToolbarService',
    'WarningService'
];

function SFTDialogCtrl($scope, dataGen, BackService, $mdDialog, $routeParams, ToastService, TranslationService,
                       SmartFormTemplateCache, ConfirmationService, ToolbarService, WarningService) {
    const POSITION_FIELDS_SAP = ["rfctextfield", "rfcpositionfield", "rfcnumberfield"]
    var ctrl = this;

    ctrl.getData = function () {
        var paramObj = {
            id: $routeParams.id
        };
        dataGen.getData($scope, paramObj, '/smartform/view').then(function () {
            defineButtons();
        });
    };

    var componentsToArray = function (components, newPrefix) {
        var result = [];
        for (var key in components) {
            var component = components[key];
            if (newPrefix) {
                component.identifier = key.replace(/newForm/, newPrefix);
            }
            // some cleanup
            if (component.hasOwnProperty("template")) {
                component.template = undefined;
            }
            if (component.hasOwnProperty("templateUrl")) {
                component.templateUrl = undefined;
            }
            if (component.hasOwnProperty("configurationPanelTemplateUrl")) {
                component.configurationPanelTemplateUrl = undefined;
            }
            if (component.hasOwnProperty("templateDescription")) {
                component.templateDescription = undefined;
            }
            if (component.layout.hasOwnProperty("isSelected")) {
                component.layout.isSelected = undefined;
            }
            if (component.component === 'time') {
                component.options = undefined;
            }
            result.push(component);
        }
        return result;
    };

    function showIdentifierPopupAndSave($event, smartForm, identifier, data) {
        var prompt = $mdDialog.prompt()
            .title($scope.trns.identifierTitle)
            .textContent($scope.trns.identifierContent)
            .placeholder($scope.trns.identifierPlaceholder)
            .targetEvent($event)
            .required(true)
            .ok(TranslationService.get('ok'))
            .cancel(TranslationService.get('abort'));
        $mdDialog.show(prompt).then(function (result) {
            smartForm.identifier = result;
            smartForm.entries = componentsToArray(SmartFormTemplateCache.getForm(identifier), result);
            realSave(identifier, data, $event);
        });
    }

    ctrl.save = function ($event) {
        var data = JSON.parse(JSON.stringify($scope.data));
        var smartForm = data.smartForm;
        var identifier = smartForm.identifier ? smartForm.identifier : "newForm";

        if (!smartForm.identifier) {
            showIdentifierPopupAndSave($event, smartForm, identifier, data);
        }
        else {
            smartForm.entries = componentsToArray(JSON.parse(JSON.stringify(SmartFormTemplateCache.getForm(identifier))));
            return realSave(identifier, data, $event);
        }
    };

    ctrl.saveCopy = function($event) {
        var data = JSON.parse(JSON.stringify($scope.data)); // Copy
        var smartForm = data.smartForm;
        smartForm.id = 0; // To save copy
        var identifier = smartForm.identifier ? smartForm.identifier : "newForm";

        showIdentifierPopupAndSave($event, smartForm, identifier, data);
    }

    var realSave = function (identifier, data, $event) {
        var isSAP = $scope.data.usageType.selected && $scope.data.usageType.selected.id === 'SAP';
        if (isSAP) {
            let components = data.smartForm.entries;
            let foundPositionNumbers = [];
            let duplicatePositionFound = false;
            for (let key in components) {
                if (POSITION_FIELDS_SAP.includes(components[key].component)) {
                    let positionInput = components[key].position;
                    let position = positionInput === undefined || positionInput === null || positionInput === "" ? "0" : components[key].position.toString();
                    if (foundPositionNumbers.includes(position)) {
                        duplicatePositionFound = true;
                        break;
                    }
                    foundPositionNumbers.push(position);
                }
            }
            if (duplicatePositionFound) {
                WarningService.showWarningDialogNoCallback($event, $scope.trns.positionNumberErrorHeader, $scope.trns.automaticNumbering,
                    TranslationService.get('abort'), [$scope.trns.positionNumberError]).then(function () {
                    var componentsAsSortedArray = components.sort(compareByGridPosition);
                    let position = 0;
                    for (var i = 0; i < componentsAsSortedArray.length; i++) {
                        if (POSITION_FIELDS_SAP.includes(componentsAsSortedArray[i].component)) {
                            componentsAsSortedArray[i].position = (position++).toString()
                        }
                    }
                    realSaveAfterValidation(identifier, data);
                })
            }
            else {
                return realSaveAfterValidation(identifier, data);
            }
        }
        else {
            return realSaveAfterValidation(identifier, data);
        }
    }

    function compareByGridPosition(a, b) {
        if (a.layout.row < b.layout.row) {
            return -1;
        }
        if (a.layout.row > b.layout.row) {
            return 1;
        }
        if (a.layout.column < b.layout.column) {
            return -1;
        }
        if (a.layout.column > b.layout.column) {
            return 1;
        }
        return 0;
    }

    var realSaveAfterValidation = function (identifier, data) {
        var paramObj = {
            smartForm: data
        };
        return dataGen.postAsForm({}, paramObj, '/smartform/save').then(function () {
            SmartFormTemplateCache.removeForm(identifier);
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.delete = function ($event) {
        ConfirmationService.showConfirmationDialog(function () {
                dataGen.postAsForm({}, {id: $scope.data.smartForm.id}, '/smartform/delete').then(function () {
                    BackService.back();
                    ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                });
            },
            $event, $scope.trns.deleteTitle, TranslationService.get('ok'), TranslationService.get('abort'), $scope.trns.deleteContent);
    };

    ctrl.getForm = function () {
        if ($scope && $scope.hasOwnProperty("data")) {
            return $scope.data.smartForm;
        }
    };

    ctrl.getUsageType = function () {
        return impactX.isDefined($scope, 'data.usageType.selected.id');
    }

    ctrl.getData();

    ctrl.showUsageType = function(ev) {
        $mdDialog.show({
            controller: 'SFTUsageTypeCtrl',
            controllerAs: 'sftUsageTypeCtrl',
            templateUrl: 'shared/smartform/templates/sft-usage-type.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                usageType: $scope.data.usageType
            }
        }).then(function (usageTypeSelected){
            $scope.data.usageType.selected = usageTypeSelected;
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {form: $scope.validationData}
            },
            {
                label: $scope.trns.delete,
                action: ctrl.delete,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.saveCopy,
                action: ctrl.saveCopy,
                type: 'validation',
                params: {form: $scope.validationData},
                condition: canSaveCopy
            },
            {
                label: $scope.trns.usageType,
                action: ctrl.showUsageType,
                type: 'dialogaction',
                condition: canEditUsageType
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return $scope.data.canDelete;
    }

    function canSaveCopy() {
        return $scope.data.smartForm.id > 0;
    }

    function canEditUsageType() {
        return true;
    }
}